// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 取消日租/时租先付续租未支付账单 用户取消或支付失败时调用。仅先付日租/时租的未支付 RENEWAL 账单可取消；回写订单租金/续租汇总。已支付或支付处理中不可取消。 POST /api/v1/app/order/rental/${param0}/cancel-renewal-payment */
export async function AppRentalControllerCancelRenewalPaymentV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentalControllerCancelRenewalPaymentV1Params,
  body: MyApi.CancelPaymentRentalOrderDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rental/${param0}/cancel-renewal-payment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 日租/时租续租 从原 endTime 延长租期并创建 RENEWAL 账单。后付：确认后立即延长；先付：支付成功后才延长。须结清全部历史租金/续租账单；同一订单取消续租达 3 次后禁止再次续租；超期使用时续租时长须覆盖已超期区间。 POST /api/v1/app/order/rental/${param0}/renewal */
export async function AppRentalControllerRenewalV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentalControllerRenewalV1Params,
  body: MyApi.RenewalRentalOrderDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRenewOrderDto>(
    `/api/v1/app/order/rental/${param0}/renewal`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建日租/时租订单 按 SKU.rentalPrice × 租赁时长计费；时长单位须与 SKU.rentalPriceUnit（day/hour）一致。支持幂等重入与一人一单。 POST /api/v1/app/order/rental/create */
export async function AppRentalControllerCreateV1(
  body: MyApi.CreateRentalOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCreateRentalOrderDto>(
    "/api/v1/app/order/rental/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
